import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [{
    path: "/",
    redirect: "/dashboard",
  },
  {
    path: "/tidak-ditemukan",
    name: "404",
    component: () =>
      import( /* webpackChunkName: "404" */ "@/views/Error/404.vue"),
    meta: {
      title: "Halaman Tidak Ditemukan | SIMWAS",
      layout: "blank",
      rule: "isPublic",
    },
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    component: () =>
      import( /* webpackChunkName: "dashboard" */ "@/views/Dashboard"),
    meta: {
      title: "Dashboard | SIMWAS",
      breadcrumbs: [{
        text: "Dashboard",
        disabled: true,
        to: "/",
      }, ],
      rule: "isLpa",
    },
  },
  {
    path: "/rpt",
    name: "Rencana Pengawasan Tahunan",
    component: () =>
      import( /* webpackChunkName: "dashboard" */ "@/views/RPT/List.vue"),
    meta: {
      title: "Rencana Pengawasan Tahunan | SIMWAS",
      breadcrumbs: [{
        text: "Rencana Pengawasan Tahunan",
        disabled: true,
        to: "/",
      }, ],
      rule: "isLogged",
    },
  },
  {
    path: "/rpt/baru",
    name: "Rencana Pengawasan Tahunan Baru",
    component: () =>
      import( /* webpackChunkName: "dashboard" */ "@/views/RPT/Form.vue"),
    meta: {
      title: "Rencana Pengawasan Tahunan Baru | SIMWAS",
      back: "/rpt",
        breadcrumbs: [{
            text: "Rencana Pengawasan Tahunan Baru",
          },
          {
            text: "Baru",
          },
        ],
        rule: "isLogged",
    },
  },
  {
    path: "/user/baru",
    name: "User Baru",
    component: () =>
      import( /* webpackChunkName: "dashboard" */ "@/views/User/Form.vue"),
    meta: {
      title: "User Baru | SIMWAS",
      back: "/user",
        breadcrumbs: [{
            text: "User Baru",
          },
          {
            text: "Baru",
          },
        ],
        rule: "isLogged",
    },
  },
  {
    path: "/rpt/:id",
    name: "Ubah Rencana Pengawasan Tahunan",
    component: () =>
      import( /* webpackChunkName: "dashboard" */ "@/views/RPT/Form.vue"),
    meta: {
      title: "Ubah Rencana Pengawasan Tahunan | SIMWAS",
      back: "/rpt",
        breadcrumbs: [{
            text: "Ubah Rencana Pengawasan Tahunan",
          },
          {
            text: "Ubah",
          },
        ],
        rule: "isLogged",
    },
  },
  {
    path: "/pkp",
    name: "Program Kerja Pengawasan",
    component: () =>
      import( /* webpackChunkName: "dashboard" */ "@/views/PKP/List.vue"),
    meta: {
      title: "Program Kerja Pengawasan | SIMWAS",
      breadcrumbs: [{
        text: "Program Kerja Pengawasan",
        disabled: true,
        to: "/",
      }, ],
      rule: "isLogged",
    },
  },
  {
    path: "/pkp/:id",
    name: "Ubah Program Kerja Pengawasan",
    component: () =>
      import( /* webpackChunkName: "dashboard" */ "@/views/PKP/Form.vue"),
    meta: {
      title: "Ubah Program Kerja Pengawasan | SIMWAS",
      back: "/pkp",
        breadcrumbs: [{
            text: "Ubah Program Kerja Pengawasan",
          },
          {
            text: "Ubah",
          },
        ],
        rule: "isLogged",
    },
  },
  {
    path: "/kertaskerja",
    name: "Kertas Kerja",
    component: () =>
      import( /* webpackChunkName: "dashboard" */ "@/views/KertasKerja/List.vue"),
    meta: {
      title: "Kertas Kerja | SIMWAS",
      breadcrumbs: [{
        text: "Kertas Kerja",
        disabled: true,
        to: "/",
      }, ],
      rule: "isLogged",
    },
  },
  {
    path: "/User",
    name: "User",
    component: () =>
      import( /* webpackChunkName: "dashboard" */ "@/views/User/List.vue"),
    meta: {
      title: "User | SIMWAS",
      breadcrumbs: [{
        text: "User",
        disabled: true,
        to: "/",
      }, ],
      rule: "isAdmin",
    },
  },
  {
    path: "/user/:id",
    name: "Ubah Kertas Kerja",
    component: () =>
      import( /* webpackChunkName: "dashboard" */ "@/views/User/Form.vue"),
    meta: {
      title: "Ubah User | SIMWAS",
      back: "/user",
        breadcrumbs: [{
            text: "Ubah User",
          },
          {
            text: "Ubah",
          },
        ],
        rule: "isAdmin",
    },
  },
  {
    path: "/kertaskerja/:id",
    name: "Ubah Kertas Kerja",
    component: () =>
      import( /* webpackChunkName: "dashboard" */ "@/views/KertasKerja/Form.vue"),
    meta: {
      title: "Ubah Kertas Kerja | SIMWAS",
      back: "/kertaskerja",
        breadcrumbs: [{
            text: "Ubah Kertas Kerja",
          },
          {
            text: "Ubah",
          },
        ],
        rule: "isLogged",
    },
  },
  {
    path: "/lps",
    name: "Laporan Sementara",
    component: () =>
      import( /* webpackChunkName: "dashboard" */ "@/views/LaporanSementara/List.vue"),
    meta: {
      title: "Laporan Sementara | SIMWAS",
      breadcrumbs: [{
        text: "Laporan Sementara",
        disabled: true,
        to: "/",
      }, ],
      rule: "isLogged",
    },
  },
  {
    path: "/lps/:id",
    name: "Ubah Laporan Sementara",
    component: () =>
      import( /* webpackChunkName: "dashboard" */ "@/views/LaporanSementara/Form.vue"),
    meta: {
      title: "Ubah Laporan Sementara | SIMWAS",
      back: "/lps",
        breadcrumbs: [{
            text: "Ubah Laporan Sementara",
          },
          {
            text: "Ubah",
          },
        ],
        rule: "isLogged",
    },
  },
  {
    path: "/lpa",
    name: "Laporan Akhir",
    component: () =>
      import( /* webpackChunkName: "dashboard" */ "@/views/LaporanAkhir/List.vue"),
    meta: {
      title: "Laporan Akhir | SIMWAS",
      breadcrumbs: [{
        text: "Laporan Akhir",
        disabled: true,
        to: "/",
      }, ],
      rule: "isLpa",
    },
  },
  {
    path: "/lpa/:id",
    name: "Ubah Laporan Akhir",
    component: () =>
      import( /* webpackChunkName: "dashboard" */ "@/views/LaporanAkhir/Form.vue"),
    meta: {
      title: "Ubah Laporan Akhir | SIMWAS",
      back: "/lpa",
        breadcrumbs: [{
            text: "Ubah Laporan Akhir",
          },
          {
            text: "Ubah",
          },
        ],
        rule: "isLpa",
    },
  },
  {
    path: "/approval",
    name: "Approval",
    component: () =>
      import( /* webpackChunkName: "dashboard" */ "@/views/Approval/List.vue"),
    meta: {
      title: "Approval | SIMWAS",
      breadcrumbs: [{
        text: "Approval",
        disabled: true,
        to: "/",
      }, ],
      rule: "isLogged",
    },
  },
  {
    path: "/approval/rpt/:id",
    name: "Approve RPT",
    component: () =>
      import( /* webpackChunkName: "dashboard" */ "@/views/Approval/RPT.vue"),
    meta: {
      title: "Approve RPT | SIMWAS",
      back: "/approval",
        breadcrumbs: [{
            text: "Approve RPT",
          },
          {
            text: "Approve",
          },
        ],
        rule: "isLogged",
    },
  },
  {
    path: "/approval/pkp/:id",
    name: "Approve PKP",
    component: () =>
      import( /* webpackChunkName: "dashboard" */ "@/views/Approval/PKP.vue"),
    meta: {
      title: "Approve PKP | SIMWAS",
      back: "/approval",
        breadcrumbs: [{
            text: "Approve PKP",
          },
          {
            text: "Approve",
          },
        ],
        rule: "isLogged",
    },
  },
  {
    path: "/approval/kertaskerja/:id",
    name: "Approve Kertas Kerja",
    component: () =>
      import( /* webpackChunkName: "dashboard" */ "@/views/Approval/KertasKerja.vue"),
    meta: {
      title: "Approve Kertas Kerja | SIMWAS",
      back: "/approval",
        breadcrumbs: [{
            text: "Approve Kertas Kerja",
          },
          {
            text: "Approve",
          },
        ],
        rule: "isLogged",
    },
  },
  {
    path: "/approval/lps/:id",
    name: "Approve Laporan Sementara",
    component: () =>
      import( /* webpackChunkName: "dashboard" */ "@/views/Approval/LaporanSementara.vue"),
    meta: {
      title: "Approve Laporan Sementara | SIMWAS",
      back: "/approval",
        breadcrumbs: [{
            text: "Approve Laporan Sementara",
          },
          {
            text: "Approve",
          },
        ],
        rule: "isLogged",
    },
  },
  {
    path: "/approval/lpa/:id",
    name: "Approve Laporan Akhir",
    component: () =>
      import( /* webpackChunkName: "dashboard" */ "@/views/Approval/LaporanAkhir.vue"),
    meta: {
      title: "Approve Laporan Akhir | SIMWAS",
      back: "/approval",
        breadcrumbs: [{
            text: "Approve Laporan Akhir",
          },
          {
            text: "Approve",
          },
        ],
        rule: "isLogged",
    },
  },
  {
    path: "/login",
    name: "Login",
    meta: {
      title: "Login | SIMWAS",
      layout: "blank",
      rule: "isPublic",
    },
    component: () => import( /* webpackChunkName: "login" */ "@/views/Login"),
  },
  {
    path: "/portal",
    name: "Portal",
    meta: {
      title: "Portal | SIMWAS",
      layout: "blank",
      rule: "isPublic",
    },
    component: () => import( /* webpackChunkName: "portal" */ "@/views/Portal"),
  },
  {
    path: "/pkk",
    name: "Pengawasan Kertas Kerja",
    component: () =>
      import( /* webpackChunkName: "dashboard" */ "@/views/PengawasanKertasKerja/List.vue"),
    meta: {
      title: "Pengawasan Kertas Kerja | SIMWAS",
      breadcrumbs: [{
        text: "Pengawasan Kertas Kerja",
        disabled: true,
        to: "/",
      }, ],
      rule: "isLogged",
    },
  },
  {
    path: "/tindaklanjut",
    name: "Tindak Lanjut",
    component: () =>
      import( /* webpackChunkName: "dashboard" */ "@/views/TindakLanjut/List.vue"),
    meta: {
      title: "Tindak Lanjut | SIMWAS",
      breadcrumbs: [{
        text: "Tindak Lanjut",
        disabled: true,
        to: "/",
      }, ],
      rule: "isInputer",
    },
  },
  {
    path: "/tindaklanjut/:id",
    name: "Ubah Tindak Lanjut",
    component: () =>
      import( /* webpackChunkName: "dashboard" */ "@/views/TindakLanjut/Form.vue"),
    meta: {
      title: "Ubah Tindak Lanjut | SIMWAS",
      back: "/tindaklanjut",
        breadcrumbs: [{
            text: "Ubah Tindak Lanjut",
          },
          {
            text: "Ubah",
          },
        ],
        rule: "isInputer",
    },
  },
  {
    path: "*",
    redirect: "/tidak-ditemukan"
  },
];

const router = new VueRouter({
  routes,
});

router.afterEach((to) => {
  Vue.nextTick(() => {
    document.title = to.meta.title || "SIMWAS";
  });
});

export default router;